import ar from './ar'
import en from './en'
import id from './id'
import ja from './ja'
import ko from './ko'
import ru from './ru'
import th from './th'
import zh from './zh'

const l10n: Record<string, I18NCookieSetLayerTextData> = { ar, en, id, ja, ko, ru, th, zh }
export default l10n
